import { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import { cn } from '../utils'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'brand-primary'
    | 'secondary-solid'
    | 'secondary-outline'
    | 'tertiary-plain'
    | 'context-menu'
    | 'text'
  'data-testid': string
}

export default function Button({
  children,
  variant = 'brand-primary',
  className,
  'data-testid': testId,
  ...props
}: PropsWithChildren<ButtonProps>) {
  const classNames = cn(
    'elm-button',
    className,

    variant === 'brand-primary' && [
      'font-bold',
      'dark:!text-white',
      'dark:!bg-red-500',
      'dark:disabled:!bg-red-400',
      'dark:disabled:!opacity-60',
      'dark:hover:!bg-red-400',
      'dark:disabled:!text-white'
    ],

    variant === 'secondary-solid' && [
      'dark:!text-cool-gray-200',
      'dark:disabled:!text-cool-gray-200',
      'dark:!bg-cool-gray-700',
      'dark:disabled:!bg-cool-gray-700',
      'dark:disabled:!opacity-60',
      'dark:hover:!bg-cool-gray-800',
      'dark:!border-cool-gray-200'
    ],

    variant === 'secondary-outline' && [
      'dark:!text-cool-gray-200',
      'dark:!border-cool-gray-200',
      'dark:hover:!bg-cool-gray-700'
    ],

    variant === 'tertiary-plain' && [
      'dark:!text-cool-gray-200',
      'dark:hover:!bg-cool-gray-700'
    ],

    variant === 'context-menu' && [
      'disabled:text-cool-gray-700',
      'disabled:opacity-40',
      'disabled:hover:bg-white'
    ]
  )

  return (
    <button
      type="button"
      className={classNames}
      data-variant={variant}
      data-testid={testId}
      {...props}
    >
      {children}
    </button>
  )
}
